import React from 'react';
import { Link } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import { Alert, Form, Button } from 'react-bootstrap';
import { Input, Checkbox, FormActions, Select, ConfirmationButton } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';

const SettingsForm = ({ error, handleSubmit, pristine, submitting, isReadonly, submitSucceeded, initialValues, roles, onRequestPasswordReset, onRequestPasswordResetUrl, t }) => {
	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			<Field name='firstName' component={Input} disabled={isReadonly} horizontal type='text' label={t('User_FirstName')}  />
			<Field name='lastName' component={Input} disabled={isReadonly} horizontal type='text' label={t('User_LastName')}  />
			<Field name='username' component={Input} disabled={isReadonly} horizontal required type='text' label={t('User_Username')} validate={validators.required} />
			<Field name='email' component={Input} disabled={isReadonly} horizontal required type='text' label={t('User_Email')} validate={[validators.required, validators.email]}  />
			<Select name='roleId' disabled={isReadonly} required horizontal label={t('User_Role')} data={roles} validate={[validators.required]} />
			<Field name='enabled' component={Checkbox} disabled={isReadonly} horizontal label={t('User_Enabled')} normalize={(v) => { return !!v }} />
			<FormActions horizontal>
				{!initialValues && <Link to='/users' className='btn btn-default'>{t('Common_BackToList')}</Link>}
				<Button type='submit' disabled={isReadonly || pristine || submitting || isReadonly} bsStyle='primary'>{t('Common_Save')}</Button>
				{initialValues && !isReadonly && <Button bsStyle='warning' className='pull-right' onClick={onRequestPasswordResetUrl}><FontAwesomeIcon icon={faLink} /> {t('SystemUser_GenerateForgottenPasswordUrl')} </Button>}
				{initialValues && !isReadonly && <ConfirmationButton icon={faEnvelope} bsStyle='warning' className='pull-right' onConfirmation={onRequestPasswordReset} confirmationTitle={t('SystemUser_ForgottenPassword')}
					confirmationMessage={t('SystemUser_ForgottenPasswordMessage')} label={t('SystemUser_ForgottenPassword')}></ConfirmationButton>}
			</FormActions>
		</Form>
	);
};

export default reduxForm({ form: 'user', enableReinitialize: true })(withTranslation()(SettingsForm));
